import React from "react";
import { IProductTileChildProps, IProductTileProps } from "./product-tile";
import TruncateMarkup from "react-truncate-markup";

interface IProductTileTitleProps
    extends Pick<IProductTileProps, "hasQuickView" | "title" | "url" | "target">,
        IProductTileChildProps {}

const ProductTileTitle: React.FC<IProductTileTitleProps> = ({
    baseClass,
    title,
    url,
    target,
    onClick,
    hasQuickView
}) => (
    <TruncateMarkup lines={2}>
        {hasQuickView ? (
            <button className={`${baseClass}__title reset-button`} type="button" onClick={onClick}>
                {title}
            </button>
        ) : (
            <a href={url} target={target} className={`${baseClass}__title reset-a`} onClick={onClick}>
                {title}
            </a>
        )}
    </TruncateMarkup>
);

export default ProductTileTitle;
